interface ItineraryCalculation {
  isKnownItinerary: boolean;
  calculatedCombinations: number;
}

export const calculateItineraryDetails = (
  propertyIds: string,
  checkIn: string | undefined,
  nights: number,
  combinations: number,
): ItineraryCalculation => {
  const numberOfProperties = propertyIds.length > 0 ? propertyIds.split(',').length : 0;
  const isKnownItinerary = numberOfProperties > 1 || (checkIn !== '' && nights > 0 && numberOfProperties === 1);
  return {
    isKnownItinerary,
    calculatedCombinations: isKnownItinerary ? numberOfProperties : combinations,
  };
};
